export const timeEn = {
  availability: {
    'all-day': 'Available all day',
    'not-available': 'Not available',
  },
  closed: 'Closed',
  days: {
    long: {
      friday: 'Friday',
      monday: 'Monday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      thursday: 'Thursday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
    },
    short: {
      friday: 'Fri',
      monday: 'Mon',
      saturday: 'Sat',
      sunday: 'Sun',
      thursday: 'Thu',
      tuesday: 'Tue',
      wednesday: 'Wed',
    },
  },
  open24: 'Open 24hrs',
  'overnight-description': '{start} to {end} the following day.',
  'recurrence-interval': {
    day: 'Daily',
    hour: 'Hourly',
    month: 'Monthly',
    week: 'Weekly',
    year: 'Annually',
  },
  'validation-errors': {
    'duplicate-special-hours': 'You already have special hours for this date',
    'invalid-overnight': 'Start time cannot be after end time.',
    'invalid-time-increment': 'Times must be in 5-minute increments',
    'overlapping-intervals': 'Hours must not overlap',
    'past-date': 'Date must not be in the past',
    'zero-length': 'Start and end times must be different',
  },
}
